import {
  faFileExport,
  faPlus,
  faRefresh
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import { generatePath, useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';

import { apiV2 } from '../../../api/ApiV2';
import PATHS from '../../../paths';
import Table from './orders-table/Table';

export const OrdersTablePageSettings = {
  isUpdateNeeded: false
};

const OrdersTablePage = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleReload = () => {
    queryClient.refetchQueries({ queryKey: ['orders'] });
  };

  return (
    <div>
      <div className="mb-9">
        <div className="row">
          <div className="col-6">
            <h2 className="mb-4">Orders</h2>
          </div>
          <div className="col-6">
            <div className="ms-xxl-auto text-end">
              <Button
                variant="link"
                className="text-900 me-4 px-0"
                onClick={handleReload}
              >
                <FontAwesomeIcon icon={faRefresh} className="fs-9 me-2" />
                Reload
              </Button>
              <Button variant="link" className="text-900 me-4 px-0">
                <FontAwesomeIcon icon={faFileExport} className="fs-9 me-2" />
                Export
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  apiV2.order.createOrder({}).then(resp => {
                    navigate(
                      generatePath(PATHS.ORDER_EDIT, { name: resp.item.Name })
                    );
                  });
                }}
              >
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                New order
              </Button>
            </div>
          </div>
        </div>
        <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-white border-top border-bottom border-200 position-relative top-1">
          <Table />
        </div>
      </div>
    </div>
  );
};

export default OrdersTablePage;
